export default function countCharacters(str, _char) {
  return str.split(_char).length - 1;
}